import React, { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { FormGrupoConformado } from "./components/FormGrupoConformado";
import { Footer } from "../../../components/Landing/Footer";
// hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
// styled component
import { Row, Col } from "antd";
import "../Usuario.style.scss";

export const GrupoConformado = () => {
  const { convocatoria, getConvocatoria } = UseVerConvocatorias();
  useEffect(() => {
    getConvocatoria();
  }, []);
  return (
    <>
      <Header />
      <BannerPostulacion convocatorias={convocatoria} />

	  <div className="container-fluid2">
        <div className="row mt-4">
          <div className="col-12 no-margin font-family-Montserrat-Regular font-size-18px">
            <span className="font-family-Montserrat-SemiBold">
              ¡GENIAL! Estás a punto de postularte en la convocatoria.
            </span>{" "}
            Por favor completa los siguientes datos. Recuerda que todos los campos son obligatorios, excepto los marcados como opcionales.
          </div>
        </div>
        <div className="col-12 mt-4">
          <div className="row">
            <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion">1</div>
            <div
              className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Datos personales
            </div>
          </div>
        </div>
      </div>
      <FormGrupoConformado convocatorias={convocatoria}/>
      <Footer />
    </>
  );
};
